/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UpdateNicknameBody
 */
export interface UpdateNicknameBody {
    /**
     * 
     * @type {string}
     * @memberof UpdateNicknameBody
     */
    nickname: string;
}

export function UpdateNicknameBodyFromJSON(json: any): UpdateNicknameBody {
    return UpdateNicknameBodyFromJSONTyped(json, false);
}

export function UpdateNicknameBodyFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateNicknameBody {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'nickname': json['nickname'],
    };
}

export function UpdateNicknameBodyToJSON(value?: UpdateNicknameBody | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'nickname': value.nickname,
    };
}


